<template lang="pug">
modal#delete-recipient-modal.text-center(
  :buttonColor='buttonColor'
  :close-button-label='$t("modal.deleteRecipient.closeButtonLabel")'
  :loading='loading'
  :process-button-label='$t("modal.deleteRecipient.processButtonLabel")'
  :title='$t("modal.deleteRecipient.title")'
  @process='$emit("process"); $refs.modal.close()'
  processButtonClass='btn-danger'
  ref='modal'
  size='sm'
)
  .text-start {{ $t('modal.deleteRecipient.message1') }}
    |
    | {{ $t('modal.deleteRecipient.message2') }}
  img.mt-4.mb-3(
    alt='draft-delete-warning'
    src='/img/ilustrations/signature-failure.svg'
  )
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import ImageLoader from '@/ui/molecules/ImageLoader.vue';

export default {
  name: 'DeleteRecipientModal',
  components: {
    Modal,
    ImageLoader,
  },
  data() {
    return {
      loading: false,
      buttonColor: true,
    };
  },
};
</script>
